import { Component, Input, OnInit } from '@angular/core';
import { AuthService, StoreService } from '@services';
import {
  faUserCircle,
  faPowerOff,
  faTasks,
  faFileExport,
  faChevronDown,
  faChevronUp,
  faCaretLeft,
} from '@fortawesome/free-solid-svg-icons';
import { ERoleActions, ERoleMode } from '@common/enums';
import { environment } from '@env/environment';

@Component({
  selector: 'prada-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() hideActions = false;
  ERoleActions = ERoleActions;
  ERoleMode = ERoleMode;
  faUserCircle = faUserCircle;
  faPowerOff = faPowerOff;
  faTasks = faTasks;
  faFileExport = faFileExport;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faCaretLeft = faCaretLeft;

  constructor(private authService: AuthService, public storeService: StoreService) {}

  ngOnInit() {}

  onLogout() {
    this.authService.signOut();
  }

  onManageScheduledJobs() {
    window.open(`${environment.baseApiUrl}hangfire`, '_blank');
  }

  onGoToHome() {
    const user = this.storeService.store.user;

    if (user.canGenerateCoupon) {
      window.location.href = environment.signOutUrl;
    } else {
      window.location.href = '/';
    }
  }
}
